// Configuration file for API endpoints and other settings
const isBrowser = typeof window !== 'undefined';
const isLocalDev =
  isBrowser &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const runtimeOrigin = isBrowser ? window.location.origin : '';
// In local dev, call local backend directly.
const defaultApiOrigin = isLocalDev ? 'http://localhost:5000' : (runtimeOrigin || 'https://vardaanglobal.com');
const envApiOrigin = process.env.REACT_APP_API_URL || '';
const resolvedApiOrigin = isLocalDev ? defaultApiOrigin : (envApiOrigin || defaultApiOrigin);
const envContactApiOrigin = process.env.REACT_APP_CONTACT_API_URL || '';
const resolvedContactApiOrigin = isLocalDev
  ? defaultApiOrigin
  : (envContactApiOrigin || envApiOrigin || defaultApiOrigin);

export const config = {
  // API base URL - explicit env override first, then runtime origin (or production fallback)
  API_URL: resolvedApiOrigin,

  // Contact form API - keep aligned with API_URL unless explicitly overridden
  CONTACT_API_URL: resolvedContactApiOrigin,
  
  // Other configuration settings can be added here
  APP_NAME: 'Vardaan Global',
  VERSION: '1.0.0',
  
  // Environment detection
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',

  // Full API URL for a path (e.g. '/api/blogs' -> 'http://localhost:5000/api/blogs')
  getFullApiUrl(path) {
    const base = this.API_URL.replace(/\/$/, '');
    const p = (path || '').replace(/^\//, '');
    return p ? `${base}/${p}` : base;
  }
}; 